
class MobileMenu {
  constructor() {
    this.lastClicked = null;
    this.toggled = false;
    this.init();
  }

  init() {
    this.setHomeIconToActive();
    this.bindEvents();
  }

  setHomeIconToActive() {
    if (window.location.pathname === '/') {
      $(
        '.light-global__wrapper .light-global__item a.home, .light-global__wrapper .light-global__item:first'
      ).addClass('active');
    }
  }

  removeActiveClass() {
    $('.light-global__menu-link').removeClass('active');
    $('.light-global__item').removeClass('active');
  }

  bindEvents() {
    $('.light-global__menu-link').on('click', (e) => this.handleMenuClick(e));
    $('.close-btn').on('click', () => this.handleCloseClick());
    $(document).on('click', (event) => this.handleDocumentClick(event));
  }

  handleMenuClick(e) {
    e.preventDefault();
    const targetId = $(e.currentTarget).attr('class').split(' ')[1] + '-popup';

    this.removeActiveClass();
    $(e.currentTarget).addClass('active');
    $(e.currentTarget).parent().addClass('active');

    if (targetId === 'home-popup') {
      window.location.href = window.globals.websiteURL + '/';
      return;
    }

    if (this.lastClicked === targetId) {
      this.toggled = !this.toggled;
      $('#' + targetId).stop(1, 1).slideToggle('fast');
      $('.popup-container').stop(1, 1).fadeToggle('slow');
      $('body').css('overflow', this.toggled ? 'auto' : 'hidden');
    } else {
      $('.popup-content').not($('#' + targetId)).slideUp('fast');
      $('#' + targetId).stop(1, 1).slideDown('fast');
      $('.popup-container').stop(1, 1).fadeIn('slow');
      $('body').css('overflow', 'hidden');
    }
    this.lastClicked = targetId;
  }

  handleCloseClick() {
    $('.popup-content').stop(1, 1).slideUp('fast');
    $('.popup-container').stop(1, 1).fadeOut('slow');
    this.lastClicked = null;
    $('body').css('overflow', 'auto');
  }

  handleDocumentClick(event) {
    if (!$(event.target).closest('.popup-content, .light-global__menu-link').length) {
      $('.popup-content').stop(1, 1).slideUp('fast');
      $('.popup-container').stop(1, 1).fadeOut('slow');
      this.lastClicked = null;
      $('body').css('overflow', 'auto');
    }
  }
}

export default MobileMenu;